// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"pa_a bik_a bik_x","FilterForm__vgroup":"pa_b bik_sv"};